import { validateIsEmpty, validateTextFieldMaxLength } from '../validator';

const MAX_FOLDER_NAME_LENGTH = 80;

export const validateScenarioFolderName = (value) => {
  const emptyError = validateIsEmpty(value);
  if (emptyError) {
    return emptyError;
  }

  return validateTextFieldMaxLength(value, MAX_FOLDER_NAME_LENGTH);
};
